import React from 'react';
import { Icon } from './Icon.js';
export const IconBook2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 2V17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M19.5 17C18.3307 18.4616 18.3307 20.5384 19.5 22", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M4 19.5L4 2L20 2L20 17", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M20 22H6.5C5.11929 22 4 20.8807 4 19.5C4 18.1193 5.11929 17 6.5 17H20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBook2.js.map